import React, { ReactNode } from 'react';

import classNames from 'classnames';

import AppCheckbox from '../../../app-checkbox/app-checkbox';

import './ui-select-item.scss';

interface UiSelectItemProps {
  selected: boolean;
  onToggleSelect: (value: string, val?: boolean) => void;
  onCheckboxItemChange: (value: string, val: boolean) => void;
  value: string;
  label: string | ReactNode;
  isMulti: boolean;
  sm?: boolean;
  lg?: boolean;
}

// eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
const UiSelectItem: React.FC<UiSelectItemProps> = ({
  selected,
  isMulti,
  onToggleSelect,
  onCheckboxItemChange,
  value,
  label,
  sm,
  lg,
}) => (
  <div
    onClick={() => {
      onToggleSelect(value);
    }}
    className={classNames('ui-select-item', {
      'ui-select-item--selected': selected,
      'ui-select-item--sm': sm,
      'ui-select-item--lg': lg,
    })}
  >
    {isMulti && (
      <AppCheckbox
        sm={sm}
        checked={selected}
        onChangeValue={(val) => {
          onCheckboxItemChange(value, val);
          onToggleSelect(value);
        }}
      />
    )}
    <span>{label}</span>
  </div>
);

export default UiSelectItem;
